import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { isNullOrEmpty } from '@interserve/angular';
import { AccountService } from '../../services/account.service';
import {
  cleanupUrlAndStoreToken,
  clearToken,
  getDecryptedSessionItem,
} from 'src/app/utility/app-token';
import { BackendApiService } from 'src/app/report/services/apis/backend-api.service';

declare const window: any;

@Component({
  selector: 'app-isbe-auth',
  imports: [CommonModule],
  template: ``,
})
export class IsbeAuthLocalComponent implements OnInit {
  /**
   *
   */
  constructor(
    private accountService: AccountService,
    private BackendApiService: BackendApiService
  ) {
    this.accountService.account$.subscribe((account) => {
      if (account === null) {
        this.logout();
      }
    });
  }

  ngOnInit(): void {
    // URLクリーンアップとトークン保存を実行
    cleanupUrlAndStoreToken();
    // アカウント情報の取得
    const loginToken = getDecryptedSessionItem('loginToken') ?? '';
    if (isNullOrEmpty(loginToken)) {
      this.logout();
      return;
    }
    const fromApp = getDecryptedSessionItem('fromApp') ?? '';
    this.BackendApiService.getAccountInfo(
      loginToken,
      fromApp === 'smtradeGarage'
    ).subscribe({
      next: (result: any) => {
        const accountInfo = result?.data;
        if (accountInfo && accountInfo?.length > 0) {
          this.accountService.accountInfo = accountInfo[0];
        } else {
          this.logout();
        }
      },
      error: (error) => {
        console.error('アカウント情報の取得に失敗しました:', error);
        this.logout();
      },
    });
  }

  onEndLogin = (accountInfo: any): void => {
    this.accountService.accountInfo = JSON.parse(accountInfo);
  };

  /**
   * セッション切れアラートを表示してタブを閉じる
   */
  logout(): void {
    // セッションストレージからトークンを削除
    clearToken();
    alert('セッションが切れました。再度ログインしてください。');

    // タブを閉じる試行
    try {
      // 現在のタブを閉じる
      window.close();

      // window.close()が機能しない場合の代替手段
      setTimeout(() => {
        // about:blankに遷移してからタブを閉じる
        window.location.href = 'about:blank';
        window.close();
      }, 100);
    } catch (error) {
      // エラーが発生した場合は、ページを空白にする
      document.body.innerHTML =
        '<h1>セッションが終了しました。このタブを閉じてください。</h1>';
    }
  }
}
